import router from "@/router";
import { apiUrl, axiosAuthGet } from "./utils";

export async function getDashboardDetails(startDate: any, endDate: any) {
    let buildingId = router.currentRoute.value.params.building;
    let buildingUrl = apiUrl + "building/details/" + buildingId + "?" + new URLSearchParams([["start", `${startDate}`]]) + "&" + new URLSearchParams([["end", `${endDate}`]]);
    let results = axiosAuthGet(buildingUrl);
    return results;
}